import { permissions } from "../permissions";

export const projectPermissions = {
  computed: {
    currentProject() {
      return this.$store.getters["projectStore/getCurrentItem"];
    }
  },
  methods: {
    hasCurrentProjectPermissions(permission) {
      return permissions.methods.hasPermissions(
        this.currentProject,
        permission
      );
    }
  }
};
